module.exports = __webpack_public_path__ + "static/media/add.53a1e3af.svg";